export default __webpack_public_path__ + "static/media/youtube-clone.40906c36.png";